import { generateClient } from 'aws-amplify/api';
import { dailyReportByUserId } from "../graphql/customQueries";

const client = generateClient();

export default async (userId, limit) => {
    const { data } = await client.graphql({
        query: dailyReportByUserId,
        variables: {
            userId,
            limit,
            sortDirection: "DESC"
        },
    });
    return data.dailyReportByUserId.items;
};
